import axios from "axios";

export const pkiAxios = axios.create();

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

const activeDirectoryService = {
    othersAccounts: async (payload) => {
        try {
            const response = await axios.post(`${API_ENDPOINT}ad/othersAccounts`, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error;
        }
    },
    othersAccountsIDX: async (payload) => {
        try {
            const response = await axios.post(`${API_ENDPOINT}idx/othersAccounts`, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error;
        }
    },
    searchOwner: async (payload) => {
        try {
            const response = await axios.post(`${API_ENDPOINT}ad/searchOwner`, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error;
        }
    },
    searchOwnerIDX: async (payload) => {
        try {
            const response = await axios.post(`${API_ENDPOINT}user/searchuser`, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error;
        }
    },
    searchAccts: async (payload) => {
        try {
            const response = await axios.post(`${API_ENDPOINT}idx/searchAccts`, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error;
        }
    },
	exceptionPolicy: async (payload) => {
        try {
            const response = await axios.post(`${API_ENDPOINT}exception/policy/submit/exceptionPolicy`, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error;
        }
    },
};

export default activeDirectoryService;